import { z } from 'zod';

export const categorySchema = z.object({
  name_uz: z
    .string()
    .trim()
    .min(2, 'categories.form.errors.nameUzRequired')
    .max(120, 'categories.form.errors.tooLong'),
  name_ru: z
    .string()
    .trim()
    .max(120, 'categories.form.errors.tooLong'),
  name_en: z
    .string()
    .trim()
    .max(120, 'categories.form.errors.tooLong'),
  name_kk: z
    .string()
    .trim()
    .max(120, 'categories.form.errors.tooLong'),
});

export type CategoryFormValues = z.infer<typeof categorySchema>;
